import { Injectable } from '@angular/core';
import { AppSettings } from '../_helpers/app.settings';
import { ApiConfig } from '../_helpers/api-config';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';
import { TokenStorageService } from '../_helpers/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(
    private http: HttpService,
    private tokenStorage: TokenStorageService
  ) { }

  updatePassword(param: any) {
    let req: Request = {
        method: AppSettings.HTTP_METHODS.POST,
        url: `${ApiConfig.updatePassword}`,
        reqBody: param.data,
        skipToken: param.skipToken,
        success: param.success ? param.success : null,
        error: param.error ? param.error : null
      }
      this.http.sendRequest(req);
  }
}
